<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
                <ion-menu-button></ion-menu-button>
                <ion-buttons slot="start">
                    <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                </ion-buttons>
                <ion-title>User Wallet Details</ion-title>
            </ion-buttons>
            
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ManageUsers />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import ManageUsers from "@/components/admin/ManageUsers.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'manageUsers',
    components: {
        ManageUsers, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonBackButton, IonTitle, IonContent
    },
    data() {
        return {
            displayBackbutton: false
        }
    },
    async mounted() {
        let userInfo = localStorage.getItem("mobileOrMail");
        // if(this.$route.params.userName) {
        if(userInfo){
            this.displayBackbutton = true;
        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>
